import { colors } from "./colors";
import { GlobalStyle } from "./GlobalStyle";

const styles = {
  colors,
  GlobalStyle,
};

export { styles };
